import * as types from '../constants/actionTypes';

const initialState = {
  loading: false,
  user: null,
  login: null,
  error: false,
  updatedOn: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // case types.LOGIN_REQUEST:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // case types.LOGIN_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     user: action.payload.user,
    //     error: false,
    //     login: action.payload.login,
    //     updatedOn: action.updatedOn,
    //   };
    // case types.LOGIN_FAIL:
    //   return {
    //     ...state,
    //     loading: false,
    //     user: null,
    //     login: null,
    //     error: action.payload,
    //   };

    case types.RESET:
      return initialState;

    case types.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
